import { render } from "./TestTracking.vue?vue&type=template&id=d047cc4c&scoped=true"
import script from "./TestTracking.vue?vue&type=script&lang=js"
export * from "./TestTracking.vue?vue&type=script&lang=js"

import "./TestTracking.vue?vue&type=style&index=0&id=d047cc4c&scoped=true&lang=css"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d047cc4c"]])

export default __exports__